export default {
    items: {
        data: null
    },
    colors: {
        data: null
    }
}